import { useEffect } from 'react';
const GoogleReviewsWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div
      className="elfsight-app-147d9d2a-1303-41c1-b6bb-51aadb88cbbe"
      data-elfsight-app-lazy
    ></div>
  );
};

export default GoogleReviewsWidget;
